import { ROAS_HORIZON } from './forecast/roasExAnteForecast';

function finiteOrNull(value) {
  return Number.isFinite(value) ? value : null;
}

export function actualRoasThroughOpenMonth(cells, includeOpenMonth) {
  const values = [];
  const source = cells || [];

  for (let index = 0; index < source.length && values.length < ROAS_HORIZON; index += 1) {
    const cell = source[index] || {};
    if (cell.isPredicted) {
      if (includeOpenMonth) {
        values.push(finiteOrNull(cell.value));
      }
      break;
    }
    values.push(finiteOrNull(cell.value));
  }

  return values;
}

export function predictedRoasContinuation(cells, solidLength) {
  const source = cells || [];
  const closedCount = Math.max(Number(solidLength) || 0, 0);
  const points = [];

  for (let index = 0; index < source.length && index < ROAS_HORIZON; index += 1) {
    const cell = source[index] || {};
    const value = finiteOrNull(cell.value);
    const joinsActuals = closedCount > 0 && index === closedCount - 1;
    if (!joinsActuals && !cell.isPredicted) {
      continue;
    }
    if (value == null) {
      continue;
    }
    points.push([index, value]);
  }

  const hasPredictedPoint = points.some(([index]) => index >= closedCount);
  return hasPredictedPoint ? points : [];
}

export function toForecastCohorts(rows) {
  const sorted = [...(rows || [])].sort(
    (left, right) => left.date.valueOf() - right.date.valueOf()
  );
  const latestId = sorted.length
    ? sorted[sorted.length - 1].date.format('YYYY-MM-DD')
    : null;

  return sorted.map((row) => {
    const id = row.date.format('YYYY-MM-DD');
    const cells = row.data?.roasByArpu;
    const roas = actualRoasThroughOpenMonth(cells, id === latestId);
    return {
      id,
      cohortMonth: row.date.format('YYYY-MM'),
      label: row.dateStr,
      uaSpend: Number(row.data?.totalUa) || 0,
      cac: Number(row.data?.cac) > 0 ? Number(row.data.cac) : null,
      firstMonthUsers: Number(row.data?.firstMonthUsers) || 0,
      isPlanned: Boolean(row.isPlanned || row.data?.isPlanned),
      roas,
      predictedRoas: predictedRoasContinuation(cells, roas.length),
    };
  });
}
